import Countdown from "./Countdown";
import { MAIN_EVENT_ISO, FLORAL_ACCENT } from "@/lib/eventConfig";
import useReveal from "@/hooks/useReveal";

export default function CountdownSection() {
  const ref = useReveal();
  return (
    <section
      className="relative py-24 sm:py-32 px-6 overflow-hidden"
      data-testid="countdown-section"
    >
      <img
        src={FLORAL_ACCENT}
        alt=""
        aria-hidden="true"
        className="absolute top-6 right-0 w-40 sm:w-56 opacity-30 pointer-events-none floaty"
      />

      <div ref={ref} className="reveal max-w-5xl mx-auto text-center">
        <p className="label-eyebrow">Counting the days</p>
        <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl text-[#4A5346] mt-6">
          Until the ceremony
        </h2>
        <p className="text-[#757E70] mt-4 italic font-serif-display text-xl">
          Saturday, September 12 · 2026 · 6:00 PM
        </p>

        <div className="mt-20">
          <Countdown targetISO={MAIN_EVENT_ISO} />
        </div>
      </div>
    </section>
  );
}
